import React, { useState, useEffect, useContext } from "react";

import './custom-tabs.css';
import Transactions, { Payin, PayinSettlement, Payout2 as Payout } from "./Transactions2";
import { Ledger } from "./Ledger";
import Balances from "./Balances";
import Profile from "./Profile";
import { GlobalContext } from "../Context/GlobalState";
import Settlement from "./Settlement";

const MyAccount2 = () => {
    const [agentId, setAgentId] = useState("");

    let {
        myAccountInfo: info,
        setMyAccountInfo,
        logoutDeveloperLogin, myAccountInfo
    } = useContext(GlobalContext);

    const [activeTab, setActiveTab] = useState(0);

    const handleTabClick = (index) => {
        setActiveTab(index);
    };
    const [name, setName] = useState('');
    const [submittedData, setSubmittedData] = useState(null);


    return (


        <div className="p-4 bg-light" style={{ fontFamily: "auto" }}>

            <div style={{ background: "#fff" }}>
                {" "}
                <div
                    className="row justify-content-between m-0 px-4 py-2"
                    style={{ background: "" }}
                >
                    <h2
                        style={{
                            margin: "0",
                            fontWeight: "bolder",
                        }}
                    >
                        My Account
                    </h2>
                    <button
                        className="btn btn-primary mx-4"
                        onClick={logoutDeveloperLogin}
                        style={{ width: "7rem" }}
                    >
                        Log Out
                    </button>
                </div>
            </div>
            <div>

                <div>

                    <div className="card m-0 p-0 pt-3">
                        <div className="card-body m-0 p-0">



                            <div className="">
                                <div
                                    defaultActiveKey="profile"
                                    className="tab-header justify-content-between"
                                    style={{
                                        display: "flex",
                                        overflowX: "auto",
                                        whiteSpace: "nowrap",
                                        padding: "10px 0",
                                        backgroundColor: "#f9f9f9",
                                        borderBottom: "1px solid #ccc",
                                    }}
                                >
                                    {[
                                        "Profile",
                                        "Balances",
                                        "Ledger",
                                        "Transactions",
                                        "Payout",
                                        "Pay - IN",
                                        "Settlement",
                                      //  "Pay - IN Settlement",
                                    ].map((label, index) => (
                                        <div
                                            key={index}
                                            className={`tab-item ${activeTab === index ? "active" : ""}`}
                                            onClick={() => handleTabClick(index)}
                                            style={{
                                                display: "inline-block",
                                                padding: "12px 24px", // Increased padding
                                                marginRight: "10px",
                                                cursor: "pointer",
                                                borderRadius: "6px",
                                                backgroundColor: activeTab === index ? "#007bff" : "#e6e6e6",
                                                color: activeTab === index ? "#fff" : "#333",
                                                fontWeight: "500",
                                                fontSize: "15px", // Slightly increased font size
                                                transition: "all 0.3s ease",
                                                minWidth: "120px", // Wider for better visibility
                                                textAlign: "center",
                                            }}
                                        >
                                            {label}
                                        </div>
                                    ))}
                                </div>



                                <div className="tab-content">
                                    {activeTab === 0 && <div><Profile agentId={agentId} /></div>}
                                    {activeTab === 1 && <div><Balances agentId={agentId} /></div>}
                                    {activeTab === 2 && <div><Ledger agentId={agentId} /></div>}
                                    {activeTab === 3 && <div> <Transactions agentId={agentId} /> </div>}
                                    {activeTab === 4 && <div> <Payout agentId={agentId} /></div>}
                                    {activeTab === 5 && <div> <Payin agentId={agentId} /></div>}
                                    {activeTab === 7 && <div> <PayinSettlement agentId={agentId} /></div>}
                                    {activeTab === 6 && <div> <Settlement agentId={agentId} /></div>}
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>

        </div>

    );
};

export default MyAccount2;